/**
 * Entity-level permissions for Flow Agents
 */
export enum EntityPermission {
  View = 'View',
  Modify = 'Modify',
  Publish = 'Publish',
  Grant = 'Grant',
}
